<template>
    <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
        <NavbarDark/>

        <section class="bg-primary position-relative">
            <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
            <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
            <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
            <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
            <div class="ht-30"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <FormTwo/>
                </div>
            </div>
            <div class="ht-30"></div>
        </section>

        <section class="gray-simple">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="item-shorting-box">
                            <div class="item-shorting clearfix">
                                <div class="left-column pull-left"><h4 class="m-0 fs-6">{{ $t('Found Result') }} {{ totalResults }} </h4></div>
                            </div>
                            <!-- <div class="item-shorting-box-right">
                                <div class="shorting-by">
                                    <ShortBy/>
                                </div>
                                <ul class="shorting-list">
                                    <li>
                                        <router-link to="/grid" class="w-12 h-12">
                                            <span class="svg-icon text-muted-2 svg-icon-2hx">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                                                    <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                                                </svg>
                                            </span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/list-layout-full" class="active w-12 h-12">
                                            <span class="svg-icon text-seegreen svg-icon-2hx">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M14 10V20C14 20.6 13.6 21 13 21H10C9.4 21 9 20.6 9 20V10C9 9.4 9.4 9 10 9H13C13.6 9 14 9.4 14 10ZM20 9H17C16.4 9 16 9.4 16 10V20C16 20.6 16.4 21 17 21H20C20.6 21 21 20.6 21 20V10C21 9.4 20.6 9 20 9Z" fill="currentColor"/>
                                                    <path d="M7 10V20C7 20.6 6.6 21 6 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H6C6.6 9 7 9.4 7 10ZM21 6V3C21 2.4 20.6 2 20 2H3C2.4 2 2 2.4 2 3V6C2 6.6 2.4 7 3 7H20C20.6 7 21 6.6 21 6Z" fill="currentColor"/>
                                                </svg>
                                            </span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <FilterModal/>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                </div>
            
                <div class="row justify-content-center g-4">
                        <div v-for="(item, index) in providers" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                        <GridLayout2 :item="item"/>
                    </div>
                </div>
                
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>
                
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>

        <FooterDark/>

        <ScrollToTop/>
    </div>
</template>

<script setup>

import { ref, onMounted, onUnmounted ,watch} from 'vue';
import axios from 'axios';
import GridLayout2 from '@/components/property/grid-layout2.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import FormTwo from '@/components/form/form-two.vue';
import { useI18n } from "vue-i18n"; 
const providers = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const totalResults = ref(0);
const perPage = ref(0);
const from = ref(0);
const to = ref(0);
const loading = ref(false);
const observer = ref(null);
const { locale } = useI18n();

const fetchProviders = async () => {
    if (loading.value || currentPage.value > totalPages.value) return;

    loading.value = true;
    try {
        const response = await axios.get(`/users/list-service-provider?page=${currentPage.value}`,{
            headers: {
                'locale': locale.value
            }
        });
        
        if (currentPage.value === 1) {
            providers.value = response.data.service_providers;
        } else {
            providers.value.push(...response.data.service_providers);
        }

        totalResults.value = response.data.total;
        perPage.value = response.data.per_page;
        from.value = (currentPage.value - 1) * perPage.value + 1;
        to.value = Math.min(from.value + providers.value.length - 1, totalResults.value);
        totalPages.value = response.data.last_page;
        currentPage.value++;

    } catch (error) {
        console.error("Error fetching providers:", error);
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value) {
            fetchProviders();
        }
    });

    const sentinel = document.getElementById('scroll-sentinel');
    if (sentinel) observer.value.observe(sentinel);
};

onMounted(() => {
    fetchProviders();
    setupObserver();
});
watch(locale, () => {
    currentPage.value = 1; 
    providers.value = [];
    fetchProviders();
});
onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
});
</script>
